import { Option } from '@mews-commander/types';
import { getPaymentMethods } from '../../constants';
import { AccountingCategoriesGroupType } from '../../types';
import { FormSection } from './FormSection';

interface Props {
    options: Option[];
    titleTextKey: Mews.TextKey;
    prefix: AccountingCategoriesGroupType;
}

export const PaymentMethods = ({ options, titleTextKey, prefix }: Props) => (
    <FormSection titleTextKey={titleTextKey} prefix={prefix} items={getPaymentMethods()} options={options} />
);
